module.exports = __webpack_public_path__ + "static/img/best_sound_mixing_lg.a6ca634.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/best_sound_mixing_lg.jpg
// module id = 81
// module chunks = 0